import React from 'react';
import PropTypes from 'prop-types';

import { InsOutsRowBoth } from './InsOutsRowBoth';
import { InsOutsRowSingle } from './InsOutsRowSingle';

import { TLCondensedCta } from '../TLCondensedCta';

/**
 * Initial render of Ins / Outs container.
 *
 * @param {object} matchRoster The match roster data.
 * @param {string} matchTitle The match title, e.g. 'Sydney Swans v GWS GIANTS'.
 * @param {string} teamDisplay The team(s) to display, i.e. 'both', 'home', or 'away'.
 * @param {object | bool} ctaConfig The ctaConfig object, if present. This populates the CTA with a link and text.
 * @returns {JSX.Element} The Ins / Outs section container.
 */

const CATEGORY_MAP = {
    ins: { title: 'IN', cssClass: 'in' },
    outs: { title: 'OUT', cssClass: 'out' }
};

const teamInsWithMilestones = (ins, milestones) => {
    return ins.map((inPlayer) => {
        const player = { ...inPlayer };

        const milestoneEvent = milestones.find(
            (milestone) =>
                milestone.player.playerId === inPlayer.player.playerId
        )?.milestoneEvent;
        if (milestoneEvent) {
            player.reason = milestoneEvent;
        }

        return player;
    });
};

export const InsOuts = ({
    matchRoster,
    matchTitle,
    teamDisplay,
    ctaConfig,
    competitionId
}) => {
    const homeTeam = matchRoster.homeTeam,
        awayTeam = matchRoster.awayTeam;

    return (
        <div className="team-lineups__section">
            {Object.keys(CATEGORY_MAP).map((category) => {
                const data = {
                    home:
                        category === 'ins'
                            ? teamInsWithMilestones(
                                  homeTeam[category],
                                  homeTeam.milestones
                              )
                            : homeTeam[category],
                    away:
                        category === 'ins'
                            ? teamInsWithMilestones(
                                  awayTeam[category],
                                  awayTeam.milestones
                              )
                            : awayTeam[category]
                };

                if (!data.home.length && !data.away.length) {
                    return null;
                }

                return teamDisplay === 'both' ? (
                    <InsOutsRowBoth
                        key={category}
                        title={CATEGORY_MAP[category].title}
                        matchTitle={matchTitle}
                        competitionId={competitionId}
                        data={data}
                        cssClass={CATEGORY_MAP[category].cssClass}
                    />
                ) : (
                    <InsOutsRowSingle
                        key={category}
                        title={CATEGORY_MAP[category].title}
                        matchTitle={matchTitle}
                        competitionId={competitionId}
                        data={data}
                        cssClass={CATEGORY_MAP[category].cssClass}
                        teamDisplay={teamDisplay}
                    />
                );
            })}
            {ctaConfig && (
                <TLCondensedCta ctaConfig={ctaConfig} matchTitle={matchTitle} />
            )}
        </div>
    );
};

InsOuts.propTypes = {
    matchRoster: PropTypes.object.isRequired,
    matchTitle: PropTypes.string.isRequired,
    teamDisplay: PropTypes.string.isRequired,
    ctaConfig: PropTypes.object,
    competitionId: PropTypes.string
};
